module.exports = __webpack_public_path__ + "static/media/ic_err_offline.e1817fbd.png";